export const initGA = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
  
    gtag("js", new Date());
    gtag("config", "G-BLPXH8QXKZ", { page_path: window.location.pathname });
  };
  
  export const trackPageView = (url) => {
    if (window.gtag) {
      window.gtag("config", "G-BLPXH8QXKZ", { page_path: url });
    }
  };
  